export function atLeastTwo(...$n: boolean[]): boolean {
  // At least two of infinite parameters should be true
  const argsLength = $n.length

  if (argsLength < 2 && !!$n[0]) {
    return true
  }

  let trueCount = 0
  for (let i = 0; i < argsLength; i++) {
    if ($n[i]) {
      trueCount++
    }
  }

  return trueCount >= 2
}

const compareAtLeastTwo = (a: boolean, b: boolean, c: boolean): boolean =>
  a ? b || c : b && c
